import { call, put } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import { TransactionApi } from "../../../generated/api";
import i18n from "../../../i18n/i18n";
import { getAPIConfig } from "../../../util/api-config";
import { handleError } from "../../../util/errorHandler";
import {
  overChargingTransaction,
  transactionAlreadyExists,
} from "../../../util/validators";
import store from "../../configureStore";
import { addWarnMessage } from "../../reducers/messageReducer";
import confirmSaga from "./modalSagas";

function setUpClient() {
  return new TransactionApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleDeleteTransaction(action: any): any {
  try {
    const transactionsClient = setUpClient();
    const reason = action.deleteTransaction.reason;

    yield transactionsClient.deleteTransaction(
      action.deleteTransaction.carePrincipalId,
      action.deleteTransaction.transactionId,
      reason
    );

    const params = {
      cardTypeId: action.cardType.id,
      carePrincipalId: action.deleteTransaction.carePrincipalId,
      personId: action.deleteTransaction.personId,
      cardSystemId: action.deleteTransaction.cardSystemId,
    };
    yield put({ type: "MODAL_CONFIRM" });
    yield put({ type: "GET_EXTENDED_CARD", params });
    yield put({ type: "GET_CARD_WITH_HISTORY_FOR_PERSON", params });
    toast.success(String(i18n.t("searchCard.manageTxns.deletedTransaction")));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleDeleteTransactionModal(): any {
  try {
    yield call(confirmSaga, "deleteTransaction");
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleUpdateTransactionModal(): any {
  try {
    yield call(confirmSaga, "updateTransaction");
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleUpdateTransaction(action: any): any {
  try {
    const transactionsClient = setUpClient();
    yield transactionsClient.updateTransaction(action.updateTransaction);
    const params = {
      cardTypeId: action.cardType.id,
      carePrincipalId: action.updateTransaction.carePrincipal.id,
      personId: action.updateTransaction.personId,
      cardSystemId: action.cardSystemId,
    };
    yield put({ type: "MODAL_CONFIRM" });
    yield put({ type: "GET_EXTENDED_CARD", params });
    yield put({ type: "GET_CARD_WITH_HISTORY_FOR_PERSON", params });
    toast.success(String(i18n.t("searchCard.manageTxns.updatedTransaction")));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleRegisterTransaction(action: any): any {
  try {
    const transactionsClient = setUpClient();
    const extendedCard = store.getState().card.extendedCard;
    if (overChargingTransaction(extendedCard, action.registerTransaction)) {
      yield put(addWarnMessage(String(i18n.t("warn.overcharged"))));
    }
    if (transactionAlreadyExists(extendedCard, action.registerTransaction)) {
      yield put(
        addWarnMessage(
          String(i18n.t("warn.existing", { amount: action.registerTransaction.amount }))
        )
      );
    }

    yield transactionsClient.registerTransaction(action.registerTransaction);
    const params = {
      cardTypeId: action.cardType.id,
      carePrincipalId: action.registerTransaction.carePrincipalId,
      personId: action.registerTransaction.personId,
    };
    yield put({ type: "GET_EXTENDED_CARD_FOR_PERSON", params });
    yield put({ type: "GET_CARD_WITH_HISTORY_FOR_PERSON", params });
    toast.success(String(i18n.t("searchCard.manageTxns.registeredTransaction")));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleRegisterTransactions(action: any): any {
  try {
    const transactionsClient = setUpClient();

    yield transactionsClient.registerTransactions(action.registration);
    const params = {
      cardTypeId: action.cardType.id,
      carePrincipalId: action.registration.carePrincipalId,
      personId: action.registration.personId,
    };
    yield put({ type: "GET_EXTENDED_CARD_FOR_PERSON", params });
    yield put({ type: "GET_CARD_WITH_HISTORY_FOR_PERSON", params });
    toast.success(String(i18n.t("searchCard.manageTxns.registeredTransactions")));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleAddTransactionModal(): any {
  try {
    yield call(confirmSaga, "addTransaction");
  } catch (error) {
    yield handleError(error);
  }
}
